// extracted by mini-css-extract-plugin
module.exports = {"descriptionWysiwyg":"description_descriptionWysiwyg__oAgOI"};